<template>
  <div class="issueListWrap" :class="{active: status.issueListViewBln}" >
    <div v-if="processDetail.processType == 'NORMAL'" class="topInfo">
      <div class="btn_area">
        <div class="btn_area_left">
          <span class="protocolCnt">기본값SET ({{ filteredExperimentList.length }}개)</span>
        </div>
        <div class="btn_area_right">
          <button v-if="experimentFlag && getExperimentResultMode == 'edit'" @click="callExperimentType">기본값SET 복사</button>
        </div>
        <span style="text-align: center;color: red;font-weight: bold">*ROW 추가 시 사용하는 기본값들의 집합</span>
      </div>
    </div>
    <List
        :experimentList="filteredExperimentList"
        :experimentFlag="experimentFlag"
    ></List>
    <BtmComp />
    <Loading :visible="loading" />
  </div>
</template>

<script> 
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import List from './list.vue';
import BtmComp from "@components/protocolEditor/BtmComp";
import {checkProtocolLink, makeNodeTotalCategory, protocolsInLink} from '@mixins/makeLinkInfo.js';
import Loading from '@common/loading.vue'
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');

export default {
  
  data () {
    return {
      protocols: [],
      emptyProtocols: [],
      protocolInfo : [],
      filterOfProtocols: [],
      emptyProtocolInfo: [],
      processDetail: {},
      processNodeData: {},
      nodeLinkInfo: [],
      clickType: false,
      selectedNodeCategory: false,
      selectedNodeName: '',
      nodeTotalCategory: {
        ANALYSIS: {cnt:0, items:{}},
        EQUIPMENT: {cnt:0, items:{}},
        MATERIAL: {cnt:0, items:{}},
        MEASUREMENT: {cnt:0, items:{}},
      },
      windowClickEvent: false,
      loading: false,
    }
  },
  props:{
    protocolEditorFlag:{
      type: Boolean,
      default: false,
    },
    experimentFlag : {
      type : Boolean,
      default : null
    },
  },
  mixins:[ CommNew ] , 
  components : { List, BtmComp, Loading },
  computed: {
    ...Hub.mapGetters([
      'getSelectedProcess','getExperimentList','getExperimentResultMode'
    ]),
    filteredExperimentList(){
      return this.getExperimentList.filter(experiment =>{
        if(this.experimentFlag === true){
          //실험입력일때
          return experiment.active && (["RELEASE","SHARE"].includes(experiment.experimentType) || (experiment.experimentType == 'CUSTOM' && experiment.userId == this.user.id))
        }else{
          //공정도수정일때
          return experiment.active && (["DEFAULT"].includes(experiment.experimentType))
        }
      }).sort((a,b) => {
        const order = {
          'RELEASE': 1,
          'DEFAULT': 1,
          'SHARE': 2,
          'CUSTOM': 3,
        };
        return order[a.experimentType] - order[b.experimentType];
      });
    },
    setTitle() {
      if(this.processDetail.processName) {
        return `
          <span>${this.processDetail.processName.replace(/<p\>|<\/p\>/gi, '')}</span> <span>${this.processDetail.processEngName.replace(/<p\>|<\/p\>/gi, '')}</span>
        ` 
      }else {
        return ''
      }
    },
    setField() {
      let field = this.processDetail.fieldName.split('>');
      field[0] = `${field[0]}<br>`;
      return field.join('>');
    }
  },
  watch: {
    selectedNodeCategory(value) {
      this.selectCategoryListWindowClick();
    },
  },
  async mounted() {
    await this.loadList();
    this.updateStatus({issueListStatus: {
      reload : this.loadList
    }})
  },
  methods: {
    ...Hub.mapActions(
        [
          "updateSelectedExperiment"
        ]
    ),
    selectCategoryListWindowClick() {
      if(this.windowClickEvent) window.removeEventListener('click', this.windowClickEvent, false);
      this.windowClickEvent = () => {
        window.removeEventListener('click', this.windowClickEvent, false);
        this.selectedNodeCategory = false;
      }
      window.addEventListener('click', this.windowClickEvent, false);
    },
    checkJSON (json) {
      let checkType = () => {
        json = JSON.parse(json);
        if(typeof json === 'string') {
          checkType();
        }
      }
      checkType();
      return json;
    },
    checkNodeCategory(item) {
      return (item === 'EQUIPMENT' ?  '장비' : false) ||
             (item === 'ANALYSIS' ?  '목적' : false) ||
             (item === 'MEASUREMENT' ? '목적' : false) ||
             (item === 'MATERIAL' ?  '재료' : false)
    },
    makeNodeTotalCategory(nodeInfo, protocolKey) {
      let categorys = Object.entries(nodeInfo);
      for(let [category, items] of categorys){
        if(!this.nodeTotalCategory[category]) continue;
        let categoryItem = this.nodeTotalCategory[category];

        for(let [title, node] of Object.entries(items)){
          if(!categoryItem.items[title]) {
            categoryItem.items[title] = [protocolKey];
          }else {
            categoryItem.items[title].push(protocolKey);
          }
        }
        this.nodeTotalCategory[category].cnt = Object.keys(categoryItem.items).length;
      }
    },
    emptyProtocolInNodes(nodes, getProtocols) {
      let protocolList = [];
      let emptyProtocols = [];
      for(let node of nodes) {
        if(node.category === 'EQUIPMENT') {
          protocolList.push(node);
        }
      }
      if(getProtocols) {
        emptyProtocols = protocolList.filter( protocol => getProtocols.findIndex( item => item.innerKeyOfProtocol === protocol.key ) < 0 );
      }
      return emptyProtocols;
    },
    moveProcess() {
      const {processId, editorType} = this.$route.query;
      this.$router.push({
        path:'/process/editor',
        query: {
          processId, editorType:'process'
        }
      })
    },
    findNodeInProtocol(key, itemName) {
      if(this.selectedNodeName === itemName) {
        this.selectedNodeName = '';
        this.filterOfProtocols = this.protocolInfo;
        return
      }
      key = key.join(' ');
      this.filterOfProtocols = [];
      for(const protocol of this.protocolInfo)  {
        if(protocol.protocol.innerKeyOfProtocol && (key.indexOf(protocol.protocol.innerKeyOfProtocol) !== -1)) {
          this.filterOfProtocols.push(protocol);
        }
      }
      this.selectedNodeName = itemName;
      // this.selectedNodeCategory = false;
      this.windowClickEvent();
      
    },
    async loadList() {
      this.loading = true;
      const {processId} = this.$route.query;
      if( !processId ) return;
      const processDetail = await this.$wApi.process.detail(null, processId);

      this.processDetail = processDetail;
      this.processNodeData = this.checkJSON(this.processDetail.json);
      if( !this.processNodeData ) {
        this.loading = false;
        return;
      }
      this.loading = false;
    },
    async callExperimentType(){
      await this.updateSelectedExperiment({
        processId : this.$route.query.processId
        ,experimentFlag : this.experimentFlag //true면 실험결과입력 모드
        ,flag : "create"
      });
    },

  },
}

</script>
  
<style lang="scss" scoped>
.issueListWrap {
  // position: fixed; top:60px; bottom: 0;
  display: flex; flex-direction: column;
  position: absolute; top:60px; /*bottom: 0;*/bottom: 300px;
  z-index: 92;
  width: 340px;
  padding: 16px;
  border-right: 1px solid #ddd;
  background: #fff;
  line-height: 1.2;
  font-size: 12px;
  transform: translate(-100%, 0);
  transition: transform 0.3s;
  @include text-prt;
  &.active {
    transform: translate(0, 0);
  }
  .topInfo {
    display: flex; justify-content: space-between;
    margin: 0 0 16px 0;
    .moveProcess {
      display: inline-flex; align-items: center;
      gap: 4px;
      // chevron-left
      &::before {
        content:'';
        display: inline-block;
        width: 16px; height: 16px;
        background:url('@/assets/icons/chevron-left.svg') center no-repeat;
        margin-top: -1px;
        filter: brightness(.6);
      }
      font-size: 14px;
      font-weight: 600;
    }
    .protocolCnt {
      color: #999;
    }
  }
  .title {
    display: flex; gap: 8px;
    margin: 0 0 16px 0;
    color: #666;
    font-weight: 600;
    .field {
      padding: 0 8px 0 0;
      border-right: 1px solid #ddd;
    }
    > div {
      display: flex; flex-direction: column;
      min-width: 50%;
      word-wrap: break-word;
    }
  }
  
  .categoryList {
    position: relative;
    .categoryCnt {
      display: flex; justify-content: space-around;
      gap: 4px;
      margin: 0 0 8px 0;
      $colorList: $color-material, $color-analysis, $color-measurement, $color-equipment;
      $colorBorderList: $color-border-material ,$color-border-process ,$color-border-analysis ,$color-border-equipment ,$color-border-protocol ,$color-border-measurement;
      $cnt: 1;
      @include text-prt;
      > li {
        border: 1.5px solid;
        display: flex; justify-content: space-between;
        width: 100%;
        padding: 4px 8px;
        border-radius: 5px;
        background-color: $color-material;
        color: #000000;
        cursor: pointer;
        span {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 14px; min-height: 14px;
          padding: 1px 2px;
          border-radius: 50%;
          background:#fff;
          color: $color-material;
          font-size: 10px;
          border: 1.5px solid;
        }
        @each $color in $colorList {
          &:nth-child(#{$cnt}) {
            background-color: $color;
            border-color: nth($colorBorderList, $cnt);
            span { 
              color: nth($colorBorderList, $cnt);
              border-color: nth($colorBorderList, $cnt);
            }
          }
          $cnt : $cnt+1;
        }
        &.active {
          .categoryItems { visibility: visible; }  
        }
        
      }
    }
    .categoryItems {
      visibility: hidden;
      position: absolute; top: calc(100% + 8px); left:0;
      width: 100%; max-height: 124px;
      border: 1px solid; border-radius: 5px;
      background: #fff;
      overflow: auto;
      z-index: 10;
      font-size: 12px; font-weight: 600; color: #333;
      > li{
        cursor: pointer;
        padding: 8px;
        &:hover { background-color: #f5f5f5; }
        &.check {
          background-color: #f5f5f5;
        }
        &.active {
          background: url('../../../assets/icons/icon-check.svg') calc(100% - 8px) center no-repeat #f5f5f5;
        }
      }
      &[data-type='EQUIPMENT'] {border-color:$color-border-equipment} 
      &[data-type='ANALYSIS'] {border-color:$color-border-analysis} 
      &[data-type='MEASUREMENT'] {border-color:$color-border-measurement} 
      &[data-type='MATERIAL'] {border-color:$color-border-material} 
      @include scrlbar;
      &.active {
        visibility: visible;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .issueListWrap {width:200px;}
}
</style>